import { Box, Portal } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { Icon } from "assets/Icons_";
import React from "react";

function ReadMorePopup({ open, onClose, clr, text }) {
  return (
    <AnimatePresence>
      {open && (
        <Portal>
          <Box
            component={motion.div}
            key="read-more-popup-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={onClose}
            sx={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              zIndex: 1300,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "16px",
            }}
          >
          <Box
            component={motion.section}
            key="read-more-popup"
            initial={{ opacity: 0, scaleY: 0 }}
            animate={{ opacity: 1, scaleY: 1 }}
            exit={{ opacity: 0, scaleY: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            onClick={(event) => event.stopPropagation()}
            sx={{
              position: "relative",
              width: "min(672px, calc(100vw - 24px))",
              borderRadius: "24px",
              overflow: "hidden",
              backgroundColor: "#fff",
              boxShadow: "0 24px 60px rgba(0, 0, 0, 0.22)",
            }}
          >
            <Box
              sx={{
                height: "40px",
                backgroundColor: clr?.buttons || "#2E6E7A",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                paddingRight: "12px",
              }}
            >
              <Icon
                click={onClose}
                icon="close"
                style={{ fontSize: "16px" }}
                isFaIcon
                color="#FFF"
              />
            </Box>

            <Box
              sx={{
                minHeight: "200px",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "24px 32px",
              }}
            >
           
                <div
                  component="p"
                  className="paragraph1-light"
                  style={{
                    margin: "0",
                    textAlign: "center",
                    color: "#1F1F1F",
                    lineHeight: 1.6,
                    whiteSpace: "pre-wrap",
                  }}
             dangerouslySetInnerHTML={{ __html: text }}
                
                />
           
            </Box>
          </Box>
        </Box>
        </Portal>
      )}
    </AnimatePresence>
  );
}

export default ReadMorePopup;
